import { Map } from 'immutable'
import _ from 'lodash'
import { LAYOUT_MODE } from './toUnits'
import { getElementDataRoot } from './getElementDataRoot'

export const getChildArea = (state, uid, mode, PageID = null) => {
  if (_.isArray(PageID)) {
    PageID = null
  }
  const pageID = PageID ? PageID : state.get('page')
  const isProject =
    state.getIn(['project', 'Settings', 'elements'], Map()).filter((elem, elemUID) => elemUID === uid).size > 0
  const props = state.getIn([...getElementDataRoot(isProject ? 'project' : pageID), 'elements', uid, 'props'], Map())
  const lgValue = props.getIn(['lg', 'gridArea'])
  const mdValue = props.getIn(['md', 'gridArea'])
  const smlValue = props.getIn(['sml', 'gridArea'])
  const smValue = props.getIn(['sm', 'gridArea'])
  const xsValue = props.getIn(['xs', 'gridArea'])
  const ssValue = props.getIn(['ss', 'gridArea'])
  const values = [lgValue, mdValue, smlValue, smValue, xsValue, ssValue]

  let valueIndex = LAYOUT_MODE.indexOf(mode)
  if (valueIndex !== -1) {
    let value = values[valueIndex]
    do {
      if (typeof value !== 'undefined' && value !== null) {
        return value
      }
      value = values[--valueIndex]
    } while (valueIndex >= 0)
  }
  return lgValue
}
